export function safeEvalArithmetic(expr: string): number | null {
  const s = expr.trim();
  if (!/^[\d+\-*/.() ]+$/.test(s)) return null;
  if (!/[+\-*/]/.test(s)) return null;
  let pos = 0;
  const skip = () => { while (pos < s.length && s[pos] === " ") pos++; };
  const parseNum = (): number => {
    skip();
    const start = pos;
    if (pos < s.length && s[pos] === "-") pos++;
    while (pos < s.length && /[\d.]/.test(s[pos])) pos++;
    if (pos === start) throw new Error("Expected number");
    const n = parseFloat(s.slice(start, pos));
    if (!isFinite(n)) throw new Error("Bad number");
    return n;
  };
  const parseFactor = (): number => {
    skip();
    if (s[pos] === "(") {
      pos++;
      const v = parseAdd();
      skip();
      if (s[pos] === ")") pos++;
      return v;
    }
    return parseNum();
  };
  const parseMul = (): number => {
    let l = parseFactor(); skip();
    while (pos < s.length && (s[pos] === "*" || s[pos] === "/")) {
      const op = s[pos++];
      const r = parseFactor(); skip();
      l = op === "*" ? l * r : r === 0 ? 0 : l / r;
    }
    return l;
  };
  const parseAdd = (): number => {
    let l = parseMul(); skip();
    while (pos < s.length && (s[pos] === "+" || s[pos] === "-")) {
      const op = s[pos++];
      const r = parseMul(); skip();
      l = op === "+" ? l + r : l - r;
    }
    return l;
  };
  try {
    const result = parseAdd();
    skip();
    if (pos !== s.length) return null;
    return isFinite(result) ? result : null;
  } catch { return null; }
}
